import '../assets/content.css';
import { jsx as r } from "react/jsx-runtime";
import c from "clsx";
import { forwardRef as m } from "react";
const a = "_content_1404h_1", p = {
  content: a
}, l = m((t, o) => {
  const { children: n, className: e, ...s } = t;
  return /* @__PURE__ */ r("span", { ...s, ref: o, className: c(p.content, e), children: n });
});
l.displayName = "Content";
export {
  l as Content
};
